import cn from 'clsx';
import PropTypes from 'prop-types';

import css from '../styles/FilterRow.module.css';

const FilterRow = ({isHighlighted, isSubRow, isHeading, children}) => {
  return (
    <div
      className={cn(css.filterRow, {
        [css.highlighted]: isHighlighted,
        [css.subRow]: isSubRow,
        [css.headingRow]: isHeading,
      })}
    >
      {children}
    </div>
  );
};

FilterRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isHighlighted: PropTypes.bool,
  isSubRow: PropTypes.bool,
  isHeading: PropTypes.bool,
};

export default FilterRow;
